import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Servizi from "./pages/Servizi";
import ServizioDetail from "./pages/ServizioDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import ProjectDetail from "./pages/ProjectDetail";
import Contatti from "./pages/Contatti";
import Pillar from "./pages/Pillar";
import SRH01 from "./pages/SRH01";
import { Privacy, Cookie } from "./pages/Legal";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AreaLogin from "./pages/area/AreaLogin";
import ClientDashboard from "./pages/area/ClientDashboard";
import ClientFormFiller from "./pages/area/ClientFormFiller";
import { getToken } from "./lib/api";
import { getClientToken } from "./lib/clientApi";

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/admin/login" replace />;
}

function RequireClient({ children }) {
  return getClientToken() ? children : <Navigate to="/area-riservata" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/servizi/:slug" element={<ServizioDetail />} />
          <Route path="/progetti" element={<Blog />} />
          <Route path="/progetti/:slug" element={<ProjectDetail />} />
          <Route path="/blog" element={<Navigate to="/progetti" replace />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/consulenza-imprese-agricole-sardegna" element={<Pillar />} />
          <Route path="/srh01-servizi-di-consulenza" element={<SRH01 />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/area-riservata" element={<AreaLogin />} />
          <Route path="/area-riservata/dashboard" element={<RequireClient><ClientDashboard /></RequireClient>} />
          <Route path="/area-riservata/documento/:id" element={<RequireClient><ClientFormFiller /></RequireClient>} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
